import React, { Component } from 'react';
import {connect } from 'react-redux';
import {getMainData,getData} from "../../Redux/ducks/mainReducer";
import {Alert,Label,Row,Col,FormGroup,Input, Button,Spinner,Table} from 'reactstrap'

import ReactJsAlert from "reactjs-alert"
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export class CurrentReport extends Component {
    state={
        isSaving:false,
        mainData:null,
        msg:null,
        addCatMsg:null,
        btnDisabled:false,
        errorMsg:null,
        successMsg:null,
    
        alertStatus :false, alertType :"error", alertTitle:null,
        qty:"",total:"",cost:"",details:"",staff:"",cat:"",name:"",myDate:"",
        reportData:null,getReport:false

    }

    componentDidMount(){
        const data = new FormData();
        this.props.getData(data,"GET_CURRENTREPORT")
    }

    componentDidUpdate(prevProps){
        const{mainData,msg,mainDataStatus,addUserStatus,getReportData} = this.props;
        
        if(mainDataStatus !== prevProps.mainDataStatus){
            if(mainDataStatus===true){
                this.setState({isSaving:false,mainData:mainData
                })
            }
        } 

        if(addUserStatus !== prevProps.addUserStatus){
            if(addUserStatus===true){
                this.setState({isSaving:false,successMsg:msg,btnDisabled:false,reportData:getReportData,getReport:true})

            }else if(addUserStatus===false){
                this.setState({isSaving:false,erroMsg:msg,btnDisabled:false,
                    alertStatus :true, alertType :"error", alertTitle:msg,getReport:false})
            }
        } 
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
    }

    generatePDF = () => {
        const { reportData } = this.state;
        
        // Create a new jsPDF instance with landscape orientation and A4 size
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4',
        });
        
        // Get page width for centering header text
        const pageWidth = doc.internal.pageSize.getWidth();
        
        // Define header text for the document
        //const headerText = ['Loan Repayment Schedule'];
        
        // Set font size for header text
        doc.setFontSize(12);
        
     
        
        // Define table headers for the two tables
        const tableHeaders = [
            ['No.', 'Name', 'Loan', 'Intrest','Subscription', 'Fines', 'Welfare','Total']
        ];
        
        // If there is loan data, process and generate table rows
        if (reportData !==null && reportData.length > 0) {
            //const rows = this.generateLoanDataRows(reportData, "OPEN");

            const { myData, lastRowIndex } = this.generateLoanDataRows(reportData, "OPEN");
    
            // Define column widths for the first table
            const columnWidths = [15, 55, 35, 35, 35, 35,35,35];
            const topMargin = 25; // Adjust top margin for the first table

            // Table title for the first table
            const tableTitle1 = "MEMBERS' CURRENT REPORT";
            
            // Set font size and add title above the first table
            doc.setFontSize(12);
            const textWidth1 = doc.getTextWidth(tableTitle1);
            const x1 = (pageWidth - textWidth1) / 2;
            const y1 = topMargin - 5; // Position the title just above the first table
            doc.text(tableTitle1, x1, y1);
            
            // Generate the first table in the PDF
            /*doc.autoTable({
                head: tableHeaders,
                body: rows,
                startY: topMargin,
                columnStyles: this.getColumnStyles(columnWidths),
                styles: this.getTableStyles(),
                headStyles: this.getHeaderStyles(),
                pageBreak: 'auto',
                margin: { top: 30, bottom: 10 },
            });*/

            doc.autoTable({
                head: tableHeaders,
                body: myData,
                startY: topMargin,
                styles: this.getTableStyles(),
                headStyles: this.getHeaderStyles(),
                columnStyles: this.getColumnStyles(columnWidths),
                /*didDrawCell: (data) => {
                    // Make the last row bold
                    if (parseInt(data.row.index) === parseInt(lastRowIndex)) {
                        doc.setFont('helvetica', 'bold'); // Make the last row bold
                        doc.setTextColor(255, 0, 0);
                        doc.setFontSize(22);
                        data.cell.text = data.cell.text.toString();
                    }
                },*/
            });
        }
    
        // Save the generated PDF
        doc.save("members_current_Report.pdf");
    };
    
    // Method to generate rows from loan data
    generateLoanDataRows = (loanData, action) => {
        let myNo = 0; // Initialize counter
        let topenLoan = 0;
        let topenContribution = 0;
        let topenFines = 0;
        let topenWelfare = 0;
        let topenIntrest = 0;
    
        let myData = [];
    
        loanData.forEach((values) => {
            myNo += 1;
            // Sum the values
            topenLoan += parseInt(values.openLoan);
            topenContribution += parseInt(values.openContribution);
            topenFines += parseInt(values.openFines);
            topenWelfare += parseInt(values.openWelfare);
            topenIntrest += parseInt(values.openIntrest);
    
            // Push a new row for each entry in loanData
            myData.push([
                myNo,
                values.name,
                parseInt(values.openLoan).toLocaleString(),
                parseInt(values.openIntrest).toLocaleString(),
                parseInt(values.openContribution).toLocaleString(),
                parseInt(values.openFines).toLocaleString(),
                parseInt(values.openWelfare).toLocaleString(),
                (
                    parseInt(values.openLoan) +
                    parseInt(values.openIntrest) +
                    parseInt(values.openContribution) +
                    parseInt(values.openFines) +
                    parseInt(values.openWelfare)
                ).toLocaleString(),
            ]);
        });
    
        // Optionally return totals (this depends on your usage of the function)
        myData.push([
            "TOTAL",
            "",
            topenLoan.toLocaleString(),
            topenIntrest.toLocaleString(),
            topenContribution.toLocaleString(),
            topenFines.toLocaleString(),
            topenWelfare.toLocaleString(),
            (
                topenLoan + 
                topenIntrest + 
                topenContribution + 
                topenFines + 
                topenWelfare
            ).toLocaleString(),
        ]);
    
        // Apply styles to make the last row bold
        const lastRowIndex = myData.length - 1;

        return {
            myData,
            lastRowIndex,
        };
    };
    
    
    // Method to get column styles
    getColumnStyles = (widths) => {
        return widths.reduce((styles, width, index) => {
            styles[index] = { cellWidth: width };
            return styles;
        }, {});
    };
    
    // Method to get table styles
    getTableStyles = () => ({
        fontSize: 9,
        cellPadding: 2,
        overflow: 'linebreak',
        halign: 'center',
        fontStyle: 'normal',
    });
    
    // Method to get header styles
    getHeaderStyles = () => ({
        fillColor: [20, 224, 239],  // Header background color
        fontStyle: 'bold',
        textColor: [3, 4, 2],        // Header text color (black)
    });


    render() {
        const {reportData} = this.state
        let catList = [];
        let staffDataList = []
        const myUserData =  this.state.mainData
       
        let openData = []
        let gotData=[]
        let paymentData = []
        
        let myNo=0
        let topenLoan = 0
        let topenContribution = 0
        let topenFines = 0
        let topenWelfare = 0
        let topenIntrest = 0
        let texpIntrest = 0
    
        if(reportData !==null){
            reportData.map((values,i) =>{
                myNo = myNo+1

                topenLoan = topenLoan+parseInt(values.openLoan)
                topenContribution = topenContribution+parseInt(values.openContribution)
                topenFines = topenFines+parseInt(values.openFines)
                topenWelfare = topenWelfare+parseInt(values.openWelfare)
                topenIntrest = topenIntrest+parseInt(values.openIntrest)
               
            

                openData.push(
                    <tr key={i}>
                        <th scope="row">{myNo}</th>
                        <td>{values.name}</td>
                        <td>{parseInt(values.openLoan).toLocaleString()}</td>
                        <td>{parseInt(values.openIntrest).toLocaleString()}</td>
                        
                        <td>{parseInt(values.openContribution).toLocaleString()}</td>
                        <td>{parseInt(values.openFines).toLocaleString()}</td>
                        <td>{parseInt(values.openWelfare).toLocaleString()}</td>
                        <td>{
                            (parseInt(values.openLoan)+
                            parseInt(values.openIntrest)+parseInt(values.openContribution)+
                            parseInt(values.openFines)+parseInt(values.openWelfare)).toLocaleString()
                            
                            }</td>
                    </tr>
                )

             

            })

            openData.push(
                <tr className='tableTotals'>
                    <th scope="row">{""}</th>
                    <td>{"TOTALS"}</td>
                    <td>{parseInt(topenLoan).toLocaleString()}</td>
                   
                    <td>{parseInt(topenIntrest).toLocaleString()}</td>
                    <td>{parseInt(topenContribution).toLocaleString()}</td>
                    <td>{parseInt(topenFines).toLocaleString()}</td>
                    <td>{parseInt(topenWelfare).toLocaleString()}</td>
                    <td>{
                        (parseInt(topenLoan)+
                        parseInt(topenIntrest)+parseInt(topenContribution)+
                        parseInt(topenFines)+parseInt(topenWelfare)).toLocaleString()
                        
                        }</td>
                </tr>
            )

        }
        return (
            <div>
                <div>
                    <Row className="mainWrraper">
                        <div className="block-header">
                            <h4>SEE CURRENT REPORT </h4>
                        </div>
                       
                    <Col xs="12" md="12" className="tableWrapper" >
                      
                        <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                        {
                            this.state.getReport ===true? 
                            <Col xs="12" >
                                <Button style={{ marginTop: 10 }}  onClick={this.generatePDF} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-success">Download Report </Button>
                            </Col>:null
                        }
                        <div className='table-container '>
                      
                            <h6></h6>
                            <Table striped responsive>
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Name</th>
                                        <th>Loan</th>
                                    
                                        <th>Intrest</th>
                                        <th>Subscription</th>
                                        <th>Fines</th>
                                        <th>Welfare</th>
                                        <th>TOTAL</th>
                                    </tr>
                                </thead>

                                {this.state.isLoading?
                                <tbody>
                                    <tr>
                                        <td colSpan="8">
                                            <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                        </td>
                                    </tr>
                                </tbody>:
                                
                                <tbody>
                                    {openData}
                                </tbody>}
                            </Table>
                          
                        </div>
                    </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    mainDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    mainData : state.mainReducer.mainData,
    getReportData : state.mainReducer.getMyData,
    addUserStatus:state.mainReducer.getMyDataStatus,
});
export default connect(
    mapStateToProps, {getMainData,getData}
)(CurrentReport)
